export default {
  "drivers.title": "المندوبون التابعون",
  "drivers.subtitle": "إدارة حسابات مندوبي المغسلة ومتابعة مهامهم المنجزة",
  "drivers.add": "إضافة مندوب",
  "drivers.scopeNote": "تخص هذه الصفحة مندوبي مغسلتك التابعين فقط. نطاق التغطية يتبع نطاق المغسلة تلقائيًا.",

  "drivers.table.photo": "المندوب",
  "drivers.table.name": "الاسم الكامل",
  "drivers.table.phone": "رقم الهاتف",
  "drivers.table.username": "اسم المستخدم",
  "drivers.table.availability": "حالة التوفر",
  "drivers.table.actions": "الإجراءات",

  "drivers.availability.available": "متاح",
  "drivers.availability.busy": "مشغول",
  "drivers.availability.unavailable": "غير متاح",
  "drivers.account.disabled": "الحساب معطل",

  "drivers.action.viewDetails": "عرض التفاصيل",
  "drivers.action.edit": "تعديل البيانات",
  "drivers.action.resetPassword": "إعادة تعيين كلمة المرور",
  "drivers.action.disable": "تعطيل الحساب",
  "drivers.action.enable": "استعادة التفعيل",
  "drivers.action.delete": "حذف الحساب",

  "drivers.legend.title": "حالة التوفر",
  "drivers.legend.text": "حالة التوفر تأتي من بيانات المندوب وتتحدث تلقائيًا أثناء عمله.",
  "drivers.legend.available": "جاهز لاستقبال المهام",
  "drivers.legend.busy": "لديه مهمة جارية",
  "drivers.legend.unavailable": "غير مستعد حاليًا",

  "drivers.empty.title": "لم تُضف مندوبين بعد",
  "drivers.empty.text": "أنشئ حسابات دخول لمندوبي المغسلة",
  "drivers.empty.action": "إضافة مندوب",
  "drivers.error": "تعذّر تحميل المندوبين",
  "drivers.errorDetail": "تعذّر تحميل بيانات المندوب",
  "drivers.notFound": "تعذّر العثور على المندوب",
  "drivers.notFoundBack": "العودة إلى المندوبين",

  "drivers.form.addTitle": "إضافة مندوب تابع",
  "drivers.form.editTitle": "تعديل بيانات المندوب",
  "drivers.form.section.basic": "البيانات الأساسية",
  "drivers.form.section.documents": "المستندات",
  "drivers.form.section.login": "بيانات الدخول",
  "drivers.form.fullName": "الاسم الكامل",
  "drivers.form.phone": "رقم الهاتف",
  "drivers.form.avatar": "الصورة الشخصية",
  "drivers.form.nationalId": "صورة الهوية الوطنية أو الإقامة",
  "drivers.form.license": "صورة رخصة القيادة",
  "drivers.form.vehicle": "صورة المركبة",
  "drivers.form.username": "اسم المستخدم",
  "drivers.form.password": "كلمة المرور",
  "drivers.form.showPassword": "إظهار كلمة المرور",
  "drivers.form.hidePassword": "إخفاء كلمة المرور",
  "drivers.form.avatarChoose": "اختيار صورة",
  "drivers.form.avatarReplace": "استبدال الصورة",
  "drivers.form.avatarRemove": "إزالة الصورة",
  "drivers.form.avatarNone": "لم تُضف صورة",
  "drivers.form.optional": "اختياري",
  "drivers.form.uploadHint": "القيود على الحجم والصيغة تتبع إعدادات النظام.",
  "drivers.form.noteLogin": "يستخدم المندوب اسم المستخدم وكلمة المرور للدخول إلى تطبيق المندوبين.",
  "drivers.form.noteNoApproval": "حساب المندوب التابع لا يحتاج اعتماد الإدارة.",
  "drivers.form.noteUsernameLocked": "اسم المستخدم غير قابل للتعديل بعد إنشاء الحساب.",
  "drivers.form.create": "إنشاء حساب المندوب",
  "drivers.form.save": "حفظ التعديلات",
  "drivers.form.cancel": "إلغاء",
  "drivers.upload.upload": "رفع ملف",
  "drivers.upload.replace": "استبدال",
  "drivers.upload.remove": "إزالة",
  "drivers.upload.noFile": "لم يُرفع ملف",

  "drivers.required.fullName": "الاسم الكامل مطلوب",
  "drivers.required.phone": "رقم الهاتف مطلوب",
  "drivers.required.username": "اسم المستخدم مطلوب",
  "drivers.required.password": "كلمة المرور مطلوبة",
  "drivers.invalid.phone": "أدخل رقم هاتف سعودي صحيح يبدأ بـ 05",
  "drivers.usernameTaken": "اسم المستخدم غير متوفر، جرّب اسمًا آخر.",
  "drivers.form.errorFix": "يرجى تصحيح الحقول المطلوبة قبل الحفظ.",
  "drivers.form.errorSave": "تعذّر حفظ البيانات، حاول مرة أخرى.",

  "drivers.reset.title": "إعادة تعيين كلمة مرور المندوب",
  "drivers.reset.account": "الحساب",
  "drivers.reset.newPassword": "كلمة المرور الجديدة",
  "drivers.reset.note": "يمكن للمغسلة تعيين كلمة مرور جديدة دون إدخال كلمة المرور الحالية للمندوب.",
  "drivers.reset.strengthNote": "قوة كلمة المرور تتبع إعدادات النظام.",
  "drivers.reset.confirm": "إعادة تعيين كلمة المرور",
  "drivers.reset.success": "تمت إعادة تعيين كلمة المرور",
  "drivers.reset.error": "تعذّرت إعادة تعيين كلمة المرور، حاول مرة أخرى.",

  "drivers.confirm.disable.title": "تعطيل حساب المندوب؟",
  "drivers.confirm.disable.text": "سيتوقف المندوب عن استقبال مهام جديدة أثناء تعطيل حسابه.",
  "drivers.confirm.disable.confirm": "تعطيل الحساب",
  "drivers.confirm.delete.title": "حذف حساب المندوب نهائيًا؟",
  "drivers.confirm.delete.text": "هل تريد حذف حساب هذا المندوب نهائيًا؟",
  "drivers.confirm.delete.confirm": "حذف الحساب",
  "drivers.confirm.cancel": "إلغاء",

  "drivers.toast.created": "تم إنشاء حساب المندوب",
  "drivers.toast.updated": "تم حفظ بيانات المندوب",
  "drivers.toast.disabled": "تم تعطيل حساب المندوب",
  "drivers.toast.enabled": "تمت استعادة تفعيل الحساب",
  "drivers.toast.deleted": "تم حذف حساب المندوب",

  "drivers.detail.back": "العودة إلى المندوبين",
  "drivers.detail.accountSummary": "ملخص الحساب",
  "drivers.detail.actions": "إجراءات الحساب",
  "drivers.detail.documents": "المستندات",
  "drivers.detail.documentsNote": "المستندات المعروضة توضيحية للمعاينة فقط ولا تمثل مستندات حقيقية.",
  "drivers.detail.document.view": "عرض المستند",
  "drivers.detail.document.none": "لم يُرفع مستند",
  "drivers.detail.document.title": "عرض المستند",
  "drivers.detail.document.demo": "مستند توضيحي للمعاينة فقط، لا يمثل مستندًا حقيقيًا.",
  "drivers.detail.document.unavailable": "لا توجد معاينة متاحة لهذا الملف في الوضع التجريبي.",

  "drivers.detail.tasks": "المهام المنجزة",
  "drivers.detail.tasks.subtitle": "سجل مهام الاستلام والتسليم المنجزة",
  "drivers.detail.tasks.empty": "لا توجد مهام منجزة لهذا المندوب بعد",
  "drivers.detail.tasks.type": "نوع المهمة",
  "drivers.detail.tasks.order": "رقم الطلب",
  "drivers.detail.tasks.date": "التاريخ والوقت",
  "drivers.detail.tasks.fee": "رسوم التوصيل",
  "drivers.detail.tasks.note": "رسوم المهمة للعرض فقط، ومحاسبة المندوب التابع تتم مع المغسلة خارجيًا.",
  "drivers.detail.tasks.error": "تعذّر تحميل سجل المهام",

  "drivers.task.pickup": "استلام",
  "drivers.task.delivery": "تسليم",

  "drivers.detail.disabledNotice": "هذا الحساب معطل مؤقتًا ولا يستقبل مهامًا جديدة حتى استعادة تفعيله.",

  "drivers.demoNote": "هذه معاينة ببيانات تجريبية."
};